(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-client-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pp-client-gallery')) {
  customElements.define('pp-client-gallery', class extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.pp-clients__viewport');
      this.track = this.querySelector('.pp-clients__track');
      this.group = this.querySelector('.pp-clients__group');
      this.hint = this.querySelector('.pp-clients__hint');
      if (!this.viewport || !this.group) return;
      this.sources = Array.from(this.group.children).filter(node => !node.hasAttribute('data-pp-copy'));
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.offset = 0;
      this.period = 0;
      this.hovered = false;
      this.focused = false;
      this.pointerInput = false;
      this.pressedPointers = new Set();
      this.visible = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.queue = () => {
        cancelAnimationFrame(this.rebuildFrame);
        this.rebuildFrame = requestAnimationFrame(() => this.rebuild());
      };
      this.viewport.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse' && matchMedia('(hover: hover)').matches) { this.hovered = true; this.sync(); }
      }, { signal });
      this.viewport.addEventListener('pointerleave', () => {
        this.hovered = false;
        this.sync();
      }, { signal });
      this.viewport.addEventListener('pointerdown', event => {
        this.pointerInput = true;
        this.focused = false;
        if (event.pointerType !== 'mouse') {
          this.hovered = false;
          this.pressedPointers.add(event.pointerId);
        }
        this.sync();
      }, { signal });
      const releasePointer = event => {
        if (this.pressedPointers.delete(event.pointerId)) this.sync();
      };
      window.addEventListener('pointerup', releasePointer, { signal });
      window.addEventListener('pointercancel', releasePointer, { signal });
      window.addEventListener('blur', () => {
        this.pressedPointers.clear();
        this.hovered = false;
        this.focused = false;
        this.sync();
      }, { signal });
      document.addEventListener('keydown', () => { this.pointerInput = false; }, { signal });
      this.viewport.addEventListener('focusin', event => {
        this.focused = !this.pointerInput && event.target.matches(':focus-visible');
        const item = event.target.closest('.pp-clients__photo');
        if (item && !this.manual) {
          const rect = item.getBoundingClientRect();
          const viewport = this.viewport.getBoundingClientRect();
          if (rect.left < viewport.left || rect.right > viewport.right) {
            this.offset = item.offsetLeft % this.period;
            this.paint();
          }
        }
        this.sync();
      }, { signal });
      this.viewport.addEventListener('focusout', event => {
        if (!this.viewport.contains(event.relatedTarget)) { this.focused = false; this.sync(); }
      }, { signal });
      this.viewport.addEventListener('keydown', event => {
        this.pointerInput = false;
        this.focused = true;
        this.sync();
        if (this.manual || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const step = this.sources[0]?.getBoundingClientRect().width || 100;
        this.offset = this.mod(this.offset + (event.key === 'ArrowRight' ? step : -step));
        this.paint();
        this.sync();
      }, { signal });
      this.addEventListener('shopify:block:select', event => {
        this.editorSelected = true;
        const selected = this.sources.find(node => node.dataset.blockId === event.detail?.blockId);
        if (selected && !this.manual && this.period) { this.offset = selected.offsetLeft % this.period; this.paint(); }
        this.sync();
      }, { signal });
      this.addEventListener('shopify:block:deselect', () => { this.editorSelected = false; this.sync(); }, { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.pressedPointers.clear();
        this.sync();
      }, { signal });
      this.motion.addEventListener('change', this.queue, { signal });
      this.resize = new ResizeObserver(this.queue);
      this.resize.observe(this.viewport);
      this.intersection = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.sync();
      });
      this.intersection.observe(this);
      this.rebuild();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resize?.disconnect();
      this.intersection?.disconnect();
      cancelAnimationFrame(this.frame);
      cancelAnimationFrame(this.rebuildFrame);
    }
    copy(node) {
      const copy = node.cloneNode(true);
      copy.dataset.ppCopy = '';
      copy.setAttribute('aria-hidden', 'true');
      for (const element of [copy, ...copy.querySelectorAll('*')]) {
        element.removeAttribute('id');
        element.removeAttribute('data-shopify-editor-block');
        if (element.matches('a, button, [tabindex]')) element.tabIndex = -1;
        if (element.matches('img')) element.alt = '';
      }
      return copy;
    }
    rebuild() {
      if (!this.isConnected) return;
      cancelAnimationFrame(this.frame);
      const progress = this.period ? this.offset / this.period : 0;
      this.track.querySelectorAll('[data-copy-group]').forEach(node => node.remove());
      this.group.replaceChildren(...this.sources);
      this.manual = this.motion.matches || this.dataset.autoplay === 'false';
      this.dataset.mode = this.manual ? 'manual' : 'auto';
      this.track.style.transform = '';
      this.viewport.scrollLeft = 0;
      if (!this.sources.length) {
        this.hidden = true;
        return;
      }
      this.hidden = false;
      const baseWidth = this.group.getBoundingClientRect().width;
      if (baseWidth <= 0) return;
      const copies = Math.max(1, Math.ceil(this.viewport.clientWidth / baseWidth));
      for (let cycle = 1; cycle < copies; cycle++) {
        this.sources.forEach(source => this.group.append(this.copy(source)));
      }
      if (!this.manual) {
        this.period = this.group.getBoundingClientRect().width;
        const second = this.group.cloneNode(true);
        second.dataset.copyGroup = '';
        second.setAttribute('aria-hidden', 'true');
        second.querySelectorAll('.pp-clients__photo').forEach(item => {
          const replacement = this.copy(item);
          item.replaceWith(replacement);
        });
        this.track.append(second);
        this.offset = progress * this.period;
        this.paint();
      } else {
        this.offset = 0;
        this.period = 0;
      }
      this.sync();
    }
    mod(value) {
      return this.period ? ((value % this.period) + this.period) % this.period : 0;
    }
    paint() {
      this.track.style.transform = `translate3d(${-this.offset}px,0,0)`;
    }
    sync() {
      cancelAnimationFrame(this.frame);
      this.lastTime = null;
      if (!this.viewport || !this.sources.length) return;
      if (this.hint) this.hint.hidden = !this.manual;
      const paused = this.manual || this.hovered || this.pressedPointers.size > 0 || this.focused || this.editorSelected || document.hidden || !this.visible;
      this.dataset.state = this.manual ? 'manual' : paused ? 'paused' : 'running';
      if (!paused && this.period) this.frame = requestAnimationFrame(time => this.tick(time));
    }
    tick(time) {
      if (!this.isConnected || this.dataset.state !== 'running') return;
      const delta = this.lastTime == null ? 0 : Math.min(100, time - this.lastTime);
      this.lastTime = time;
      const speed = Math.max(5, Number(this.dataset.speed) || 35);
      const direction = this.dataset.direction === 'right' ? -1 : 1;
      this.offset = this.mod(this.offset + direction * speed * delta / 1000);
      this.paint();
      this.frame = requestAnimationFrame(next => this.tick(next));
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pp-featured-product')) {
    customElements.define('pp-featured-product', class extends HTMLElement {
      connectedCallback() {
        this.onClick = (event) => {
          const thumbnail = event.target.closest('[data-show-image]');
          if (thumbnail && this.contains(thumbnail)) this.showImage(thumbnail.dataset.showImage);
        };
        this.onChange = (event) => {
          if (event.target.matches('[data-variant-select]')) this.updateVariant(event.target.selectedOptions[0]);
        };
        this.addEventListener('click', this.onClick);
        this.addEventListener('change', this.onChange);
        const buttonLabel = this.querySelector('.product-form__submit > span');
        this.addLabel = this.querySelector('[data-add-label]')?.dataset.addLabel || window.variantStrings?.addToCart || buttonLabel?.textContent.trim();
        if (buttonLabel && !buttonLabel.closest('button').disabled) buttonLabel.textContent = this.addLabel;
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('change', this.onChange);
      }
      showImage(id) {
        if (!id || !Array.from(this.querySelectorAll('[data-image-id]')).some(slide => slide.dataset.imageId === id)) return;
        this.querySelectorAll('[data-image-id]').forEach(slide => { slide.hidden = slide.dataset.imageId !== id; });
        this.querySelectorAll('[data-show-image]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.showImage === id)));
      }
      updateVariant(option) {
        const form = this.querySelector('product-form');
        if (!form || !option) return;
        const input = form.querySelector('[name="id"]');
        input.value = option.value;
        input.dispatchEvent(new Event('change', { bubbles:true }));
        const available = option.dataset.available === 'true';
        const button = form.querySelector('[type="submit"]');
        button.disabled = !available;
        button.removeAttribute('aria-disabled');
        button.querySelector('span').textContent = available ? this.addLabel : (window.variantStrings?.soldOut || option.textContent);
        form.querySelector('.product-form__error-message-wrapper')?.setAttribute('hidden', '');
        this.querySelectorAll('[data-current-price]').forEach(price => { price.textContent = option.dataset.price; });
        this.querySelectorAll('[data-compare-price]').forEach(price => { price.hidden = !option.dataset.compare; });
        this.querySelectorAll('[data-compare-value]').forEach(price => { price.textContent = option.dataset.compare; });
        this.querySelectorAll('[data-unit-price]').forEach(price => { price.hidden = !option.dataset.unit; price.textContent = option.dataset.unit; });
        const quantity = this.querySelector('[name="quantity"]');
        if (quantity) {
          quantity.min = option.dataset.min || '1'; quantity.step = option.dataset.step || '1';
          if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
          quantity.value = quantity.min;
        }
        this.querySelectorAll('[data-product-link]').forEach(link => {
          const url = new URL(link.href); url.searchParams.set('variant',option.value); link.href = url;
        });
        this.showImage(option.dataset.image);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
